import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { miniTable } from "MODULES/shared/decorators";
import { shortDateYY, monthYear } from "LIB/formatters/date";
import { getFirstNameLastInitial, truncate } from "LIB/formatters/text";
import { dollars } from "LIB/formatters/currency";
import withSubscription from "MODULES/Subscription/withSubscription";
import {
  INCOMING_LINE_ITEMS,
  NO_QUOTE
} from "MODULES/IncomingQuotes/constants";
import LineItemStatusCell from "MODULES/shared/components/LineItemStatusCell";
import { NoteTooltipTableCell } from "MODULES/shared/components/NoteTooltip";
import {
  DataTable,
  LinkedTableRow,
  CompanyName,
  LineItemQtyCell
} from "MODULES/shared/components";
import api from "APP_ROOT/api";
import ModifiedFlag from "MODULES/parts/components/ModifiedFlag";
import { CREATED_AT } from "APP_ROOT/constants";
import { IncidentRelatedFlag } from "MODULES/IncomingQuotes/shared/IncidentRelatedFlag";
import { AsIsFlag } from "MODULES/IncomingQuotes/shared/AsIsFlag";
import classNames from "classnames";
import _ from "lodash";

export class LineItemsTable extends Component {
  static propTypes = {
    inForm: PropTypes.bool,
    results: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        incoming_quote_id: PropTypes.number.isRequired,
        quote_type: PropTypes.string.isRequired,
        dom: PropTypes.string,
        condition: PropTypes.string,
        company_name: PropTypes.string,
        legacy_company_name: PropTypes.string,
        cost: PropTypes.string
      })
    ).isRequired,
    loading: PropTypes.bool.isRequired,
    limitResults: PropTypes.bool
  };

  renderRow = (lineItem, i) => (
    <LinkedTableRow
      key={lineItem.id}
      className="clickable"
      to={`/incoming-quotes/${lineItem.quote_uuid}`}
    >
      <td
        style={{
          backgroundColor: this.props.inForm ? "#383838" : "#292929"
        }}
      >
        <div style={{ whiteSpace: "nowrap" }}>
          <div style={{ textAlign: "right" }}>
            <LineItemQtyCell lineItem={lineItem} showFull type="IQ" />
            {i + 1}
          </div>
        </div>
      </td>
      <LineItemStatusCell lineItem={lineItem}>
        <span className={lineItem.updated_tracked_fields_at && "text-yellow"}>
          {shortDateYY(
            lineItem.updated_tracked_fields_at || lineItem.created_at
          )}
        </span>
      </LineItemStatusCell>
      <td className="text-nowrap">
        <CompanyName
          flattenedCompany={lineItem}
          truncateAt={this.props.inForm ? 8 : 18}
        />
      </td>
      <td className="text-nowrap">
        {truncate(
          getFirstNameLastInitial(_.get(lineItem, "buyer.full_name")),
          14
        )}
      </td>
      <td className="text-nowrap">
        {INCOMING_LINE_ITEMS.quoteType[lineItem.quote_type].abbrev}
      </td>
      <td className="text-nowrap">
        {lineItem.trace_type &&
          INCOMING_LINE_ITEMS.traceTypes[lineItem.trace_type].abbrev}
      </td>
      <td className="text-center">{monthYear(lineItem.tag_date)}</td>
      <td>{lineItem.modified && <ModifiedFlag />}</td>
      <td className="text-nowrap">
        {lineItem.condition &&
          lineItem.quote_type !== NO_QUOTE &&
          INCOMING_LINE_ITEMS.condition[lineItem.condition].abbrev}
        <IncidentRelatedFlag lineItem={lineItem} />
        <AsIsFlag lineItem={lineItem} className="m-l-5" />
      </td>
      <td className="text-center">{lineItem.quantity}</td>
      <td className="text-center">{truncate(lineItem.lead_time, 3)}</td>
      <td className="text-right">
        {lineItem.cost
          ? dollars(lineItem.cost)
          : dollars(lineItem.exchange_fee)}
      </td>
      {!this.props.inForm &&
        (lineItem.quote_type === "awaiting_reply" ? (
          <NoteTooltipTableCell
            note={[lineItem.notes, lineItem.external_note]
              .filter(n => n !== null && n !== "")
              .join(" | ")}
            className={classNames({ "link-muted": lineItem.cancelled })}
          />
        ) : (
          <NoteTooltipTableCell note={lineItem.notes} />
        ))}
    </LinkedTableRow>
  );

  render() {
    const { inForm, results, limitResults } = this.props;
    const modifiedResults = limitResults ? results.slice(0, 3) : results;
    return (
      <DataTable.Mini loading={this.props.loading} numbered>
        <DataTable.Head>
          <th />
          <th>Date</th>
          <th>Vendor</th>
          <th>Buyer</th>
          <th>Type</th>
          <th>Trace</th>
          <th className="text-center">Tag Date</th>
          <th />
          <th>CD</th>
          <th className="text-center">QTY</th>
          <th className="text-center">LT</th>
          <th className="text-right">Exch/Cost</th>
          {!inForm && <th />}
        </DataTable.Head>
        <DataTable.Body>{modifiedResults.map(this.renderRow)}</DataTable.Body>
      </DataTable.Mini>
    );
  }
}

const withResults = miniTable(({ match }, params) =>
  api.parts.incomingQuoteLineItems.search(
    match.params.id,
    Object.assign(params, { sort: CREATED_AT })
  )
);

export default withRouter(
  withResults(withSubscription("IncomingQuoteLineItem")(LineItemsTable))
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/IncomingQuotes/LineItemsTable.jsx